module.exports = __webpack_public_path__ + "img/c04_buildingtechtemper_Normal_ua.98c3bd7f.webp";